$(function(){
    console.log($(".application_send_data_to_danish_statistics").length)
    if($(".application_send_data_to_danish_statistics").length) {
        $(".radio").click(check_danish_statistics_data_true_selected);
        check_danish_statistics_data_true_selected()
    }
});

function check_danish_statistics_data_true_selected() {
    if ($("input[name='application[send_data_to_danish_statistics]']:checked").val() == 'yes') {
        $("div.danish_statistics_data_fields").show()
        $('div.delivery_fields :input').val('');
        $("div.delivery_fields").hide()
    } else {
        $("div.delivery_fields").show()
        $('div.danish_statistics_data_fields :input').val('');
        $("div.danish_statistics_data_fields").hide()
    }
}